

// AsgmntL


import "./AsgmntL.css"
import img1 from "../../Images/UNSMoodleLogin.png"
import img2 from "../../Images/UNSMyCourses.png"
import img3 from "../../Images/UNSEditMode.png"
import img4 from "../../Images/RespectiveCourse.png"
import img5 from "../../Images/AsignmentAdd.png"
import img6 from "../../Images/Asignment1.png"
import img7 from "../../Images/UNSRoomD2.png"
import img8 from "../../Images/Asignment5.png"

import img9 from "../../Images/AddSubmissionButton.png"
import img10 from "../../Images/ChooseSubmissionButton.png"
import img11 from "../../Images/ChooseSubmissionButton2.png"
import img12 from "../../Images/ChooseSubmissionButton3.png"
import img13 from "../../Images/ChooseSubmissionButton4.png"
import img14 from "../../Images/ChooseSubmissionButton5.png"
import img15 from "../../Images/ChooseSubmissionButton6.png"
import img16 from "../../Images/ChooseSubmissionButton7.png"
import img17 from "../../Images/ChooseSubmissionButton10.png"
import img18 from "../../Images/ChooseSubmissionButton9.png"
// import { Outlet } from "react-router-dom";


function AsgmntL() {
    return (
      <div className="AsgmntLCover"> 

            <h1>Assignments</h1>
              <div className="ContentOutput">
                      <div className="Hyperlinks">
                          <ul>
                              <li><a href="#Section1">Introduction to moodle</a>  </li>
                              <li><a href="#Section2">How to find my Assignments</a>  </li>
                              <li><a href="#Section3">How to submit an Assignment</a> </li>
                              <li><a href="#Section4">How to edit a submission</a> </li>
                              {/* <li><a href="#Section4">How to remove a submission</a> </li> */}
                              <li><a href="#Section4">How to check submission status</a> </li>
                             
                          </ul>

                      </div>

                      <div className="resourceSection">
                      
                      <section id="Section1">

                            <div className="contentWhole">  

                                  <div className="contentHeading">  
                                        <h3>Introduction to Moodle</h3>
                                        </div>
                                              <div className="contentParagraph"> 

                                                  <p> 
                                                      Moodle is the online learning platform used by Unilus. It contains individual spaces for each of your modules, where you can access a variety of information, materials, and activities. 
                                                  </p>    
                                                  <p> 
                                                    Almost all taught modules have a Moodle space.

                                                  </p>    

                                            </div>
                                  <div className="contentImage">  

                                 </div>


                            </div>


                      </section>

                      <section id="Section2">   

                      <div className="contentWhole">  

                              <div className="contentHeading">  
                                    <h2>How to find links to my Assignments</h2>
                                    </div>
                                          <div className="contentParagraph"> 

                                          <p> 
                                                <b> STEP 1 :</b> Navigate to My courses
                                          </p>    
                                          <p> 
                                                {/* Almost all taught modules have a Moodle space. */}

                                          </p>    

                                    </div>
                              <div className="contentImage">  
                              <img src={img2} />

                              </div>
                                          <div className="contentParagraph"> 

                                          <p> 
                                          <b>
                                                STEP 2 : </b>Go to the respective course with the Assignment
                                          </p>    
                                          <p> 
                                                {/* Almost all taught modules have a Moodle space. */}

                                          </p>    

                                    </div>
                              <div className="contentImage">  
                              <img src={img4} />

                              </div>
                                          <div className="contentParagraph"> 

                                          <p> 
                                                <b>STEP 3 :</b> Scroll through the course resources looking for Activity titles like <b>"LINK TO ASSIGNMENT"</b> and click on it
                                          </p>    
                                          <p> 
                                                {/* Almost all taught modules have a Moodle space. */}

                                          </p>    

                                    </div>
                              <div className="contentImage">  
                              <img src={img8} />

                              </div>
                              
                                    
                              


                              </div>

                   

                      </section>
                      <section id="Section3">
                      <div className="contentWhole">  

                                                <div className="contentHeading">  
                                                      <h2>How to submit an Assignment</h2>
                                                      </div>
                                                            <div className="contentParagraph"> 

                                                            <p> 
                                                                  <b> STEP 1 :</b> Navigate to My courses
                                                            </p>    
                                                            <p> 
                                                                  {/* Almost all taught modules have a Moodle space. */}

                                                            </p>    

                                                      </div>
                                                <div className="contentImage">  
                                                <img src={img2} />

                                                </div>
                                                            <div className="contentParagraph"> 

                                                            <p> 
                                                            <b>
                                                                  STEP 2 : </b>Go to the respective course with the Assignment
                                                            </p>    
                                                            <p> 
                                                                  {/* Almost all taught modules have a Moodle space. */}

                                                            </p>    

                                                      </div>
                                                <div className="contentImage">  
                                                <img src={img4} />

                                                </div>
                                                            <div className="contentParagraph"> 

                                                            <p> 
                                                                  <b>STEP 3 :</b> Scroll through the course resources looking for Activity titles like <b>"ASSIGNMENT LINK"</b> and click on it
                                                            </p>    
                                                            <p> 
                                                                  {/* Almost all taught modules have a Moodle space. */}

                                                            </p>    

                                                      </div>
                                                <div className="contentImage">  
                                                <img src={img8} />

                                                </div>
                                                            <div className="contentParagraph"> 

                                                            <p> 
                                                                  <b>STEP 4 :</b> Navigate to the <b>"Add Submission"</b> button and click on it
                                                            </p>    
                                                            <p> 
                                                                  {/* Almost all taught modules have a Moodle space. */}

                                                            </p>    

                                                      </div>
                                                <div className="contentImage">  
                                                <img src={img9} />

                                                </div>
                                                            <div className="contentParagraph"> 

                                                            <p> 
                                                                  <b>STEP 5 :</b> Scroll down to the <b>"File Icon"</b> and click on it
                                                            </p>    
                                                            <p> 
                                                                  {/* Almost all taught modules have a Moodle space. */}

                                                            </p>    

                                                      </div>
                                                <div className="contentImage">  
                                                <img src={img10} />

                                                </div>
                                                            <div className="contentParagraph"> 

                                                            <p> 
                                                                  <b>STEP 6 :</b> Navigate to and click on <b>"Upload from computer"</b> and click on it
                                                            </p>    
                                                            <p> 
                                                                  {/* Almost all taught modules have a Moodle space. */}

                                                            </p>    

                                                      </div>
                                                <div className="contentImage">  
                                                <img src={img11} />

                                                </div>
                                                            <div className="contentParagraph"> 

                                                            <p> 
                                                                  <b>STEP 7 :</b> Click on <b>"Choose File"</b> and select respective file
                                                            </p>    
                                                            <p> 
                                                                  {/* Almost all taught modules have a Moodle space. */}

                                                            </p>    

                                                      </div>
                                                <div className="contentImage">  
                                                <img src={img12} />

                                                </div>
                                                            <div className="contentParagraph"> 

                                                            <p> 
                                                                  <b>STEP 8 :</b> Rename the upload the click on <b>"UPLOAD FILE"</b> 
                                                            </p>    
                                                            <p> 
                                                                  {/* Almost all taught modules have a Moodle space. */}

                                                            </p>    

                                                      </div>
                                                <div className="contentImage">  
                                                <img src={img14} />

                                                </div>
                                                            <div className="contentParagraph"> 

                                                            <p> 
                                                                  <b>STEP 9 :</b> Click on <b>"Save Changes"</b>
                                                            </p>    
                                                            <p> 
                                                                  {/* Almost all taught modules have a Moodle space. */}

                                                            </p>    

                                                      </div>
                                                <div className="contentImage">  
                                                <img src={img15} />

                                                </div>
                                                            <div className="contentParagraph"> 

                                                            <p> 
                                                                  <b>STEP 9 :</b> Redirect to submission status screen
                                                            </p>    
                                                            <p> 
                                                                  {/* Almost all taught modules have a Moodle space. */}

                                                            </p>    

                                                      </div>
                                                <div className="contentImage">  
                                                <img src={img18} />

                                                </div>
                                                     

                                                </div>





                  </section>
            <section id="Section4"> 

            <div className="contentWhole">  

                        <div className="contentHeading">  
                              <h2>How to edit a submission</h2>
                              </div>
                                    <div className="contentParagraph"> 

                                    <p> 
                                          <b> STEP 1 :</b> Navigate to My courses
                                    </p>    
                                    <p> 
                                          {/* Almost all taught modules have a Moodle space. */}

                                    </p>    

                              </div>
                        <div className="contentImage">  
                        <img src={img2} />

                        </div>
                                    <div className="contentParagraph"> 

                                    <p> 
                                    <b>
                                          STEP 2 : </b>Go to the respective course with the Assignment
                                    </p>    
                                    <p> 
                                          {/* Almost all taught modules have a Moodle space. */}

                                    </p>    

                              </div>
                        <div className="contentImage">  
                        <img src={img4} />

                        </div>
                                    <div className="contentParagraph"> 

                                    <p> 
                                          <b>STEP 3 :</b> Scroll through the course resources looking for Activity titles like <b>"LINK TO ASSIGNMENT"</b> and click on it
                                    </p>    
                                    <p> 
                                          {/* Almost all taught modules have a Moodle space. */}

                                    </p>    

                              </div>
                        <div className="contentImage">  
                        <img src={img8} />

                        </div>
                                    <div className="contentParagraph"> 

                                    <p> 
                                          <b>STEP 4 :</b> Click on Edit Submission,then choose the respective edited file on your computer
                                    </p>    
                                    <p> 
                                          {/* Almost all taught modules have a Moodle space. */}

                                    </p>    

                              </div>
                        <div className="contentImage">  
                        <img src={img17} />

                        </div>

                              



                        </div>



                              



                        
                        </section>
                        <section id="Section4">

                        <div className="contentWhole">  

            <div className="contentHeading">  
                  <h2>How to check submission status</h2>
                  </div>
                        <div className="contentParagraph"> 

                        <p> 
                              <b> STEP 1 :</b> Navigate to My courses
                        </p>    
                        <p> 
                              {/* Almost all taught modules have a Moodle space. */}

                        </p>    

                  </div>
            <div className="contentImage">  
            <img src={img2} />

            </div>
                        <div className="contentParagraph"> 

                        <p> 
                        <b>
                              STEP 2 : </b>Go to the respective course with the Assignment
                        </p>    
                        <p> 
                              {/* Almost all taught modules have a Moodle space. */}

                        </p>    

                  </div>
            <div className="contentImage">  
            <img src={img4} />

            </div>
                        <div className="contentParagraph"> 

                        <p> 
                              <b>STEP 3 :</b> Scroll through the course resources looking for Activity titles like <b>"LINK TO ASSIGNMENT"</b> and click on it
                        </p>    
                        <p> 
                              {/* Almost all taught modules have a Moodle space. */}

                        </p>    

                  </div>
            <div className="contentImage">  
            <img src={img8} />

            </div>
                        <div className="contentParagraph"> 

                        <p> 
                              <b>STEP 4 :</b> A screen with the submission status will open up
                        </p>    
                        <p> 
                              {/* Almost all taught modules have a Moodle space. */}

                        </p>    

                  </div>
            <div className="contentImage">  
            <img src={img17} />

            </div>

                  



            </div>






            </section>



                      </div>




                </div>
     
      </div>
    );
  }
  
  export default AsgmntL;
  